export default __webpack_public_path__ + "static/media/QwVideo1.0caed5ea.mp4";